import type { NullableIR, SchemaIR } from "../../types.js";
import type { FastGen, SlowGen } from "../context.js";
import { fastSentinelWrapper } from "../context.js";
import { emit } from "../emit.js";

export function slowNullable(ir: SchemaIR & { type: "nullable" }, g: SlowGen): string {
  // Pass-through wrapper: forward the union abort flag (see slowOptional).
  return `${emit`
    if(${g.input}!==null){
      ${g.visit(ir.inner, { aborted: g.aborted })}
    }
  `}\n`;
}

export function fastNullable(ir: NullableIR, g: FastGen): string | null {
  return fastSentinelWrapper(g, ir.inner, "===null", "||");
}
